import { CreateFileInput } from "../../../Shared/dto/create-file-input";
import { PageOptionsDto } from "../../../Shared/dto/page.options.dto";
import { HttpService } from "../../../Shared/Utils/HttpService";
import { AuthService } from "../../Auth/services/AuthService";
import { CreateCompanyInput } from "../models/CreateCompanyInput";

export class CompanyService {
  static async create(createCompanyInput: CreateCompanyInput) {
    const response = await HttpService.request({
      url: "/companies/create",
      method: "POST",
      data: createCompanyInput,
    });
    await AuthService.reAuthenticate();
    return response;
  }

  static async createFromFile(createFromFileInput: CreateFileInput) {
    return await HttpService.request({
      url: "/companies/create/from-file",
      method: "POST",
      data: createFromFileInput,
    });
  }

  static async getById(id: string) {
    return await HttpService.request({
      url: `/companies/find/${id}`,
      method: "GET",
    });
  }

  static async update(id: string, updateCompanyInput: CreateCompanyInput) {
    return await HttpService.request({
      url: `/companies/${id}`,
      method: "PUT",
      data: updateCompanyInput,
    });
  }

  static async deleteOne(id: string) {
    return await HttpService.request({
      url: `/companies/${id}`,
      method: "DELETE",
    });
  }

  static async delete(ids: string[]) {
    return await HttpService.request({
      url: `/companies/${JSON.stringify(ids)}`,
      method: "DELETE",
    });
  }

  static async getAll(pageOptions: PageOptionsDto) {
    const queryParams = new URLSearchParams({
      order: pageOptions.order || "DESC",
      page: pageOptions.page.toString(),
      query: pageOptions.query || "",
      take: pageOptions.take.toString(),
    }).toString();

    return await HttpService.request({
      url: `/companies/find?${queryParams}`,
      method: "GET",
    });
  }

  static async findAll(findOptions: Object) {
    const query = encodeURIComponent(JSON.stringify(findOptions));
    return await HttpService.request({
      url: `/companies?findOptions=${query}`,
      method: "GET",
    });
  }

  static async search(query: string) {
    return await HttpService.request({
      url: `/companies/search?query=${encodeURIComponent(query)}`,
      method: "GET",
    });
  }

  static async getProfile() {
    return await HttpService.request({
      url: "/companies/profile",
      method: "GET",
    });
  }

  static async updateProfile(updateCompanyInput: CreateCompanyInput) {
    return await HttpService.request({
      url: "/companies/profile",
      method: "PUT",
      data: updateCompanyInput,
    });
  }

  static async getAccount(id: string) {
    return await HttpService.request({
      url: `/companies/find/account/${id}`,
      method: "GET",
    });
  }
}
